export default "__VITE_ASSET__hvC3YX8H__"